import { IncentiveIssues, dhis_states, incentive_states } from '../../api/getAbhaMetricsDashboard';

export type all_states = incentive_states | dhis_states;

export const next_state: Record<all_states, all_states> = {
    'dhis-registration': 'dhis-approval',
    'dhis-approval': 'claim-incentive',
    'claim-incentive': 'confirm-incentive',
    'confirm-incentive': 'incentive-recieved',
    error: 'incentive-recieved',
    'incentive-not-recieved': 'incentive-recieved',
    'incentive-recieved': 'incentive-recieved',
    'dhis-end': 'dhis-end',
};

const claimIncentiveSuccessStatuses = [
    'confirm-incentive',
    'incentive-not-recieved',
    'incentive-recieved',
];

export const dhis_steps = (
    currMonthStatus: {
        status?: all_states | undefined;
        month?: string | undefined;
        amount?: number | undefined;
        issue?: IncentiveIssues | undefined;
        dhisstatus?: dhis_states | undefined;
        dhisissues?: IncentiveIssues | undefined;
    },
    dhisStatus?: dhis_states,
): { id: string; name: string; status: 'error' | 'finish' | 'process' | 'wait' }[] => [
    {
        id: 'dhis_registration',
        name: 'DHIS Registration',
        status:
            dhisStatus === 'dhis-end'
                ? 'finish'
                : currMonthStatus.dhisissues?.id && !currMonthStatus.dhisissues?.isResolved
                ? 'error'
                : 'process',
    },
    {
        id: 'claim_incentives',
        name: 'Claim incentives',
        status:
            dhisStatus !== 'dhis-end'
                ? 'wait'
                : currMonthStatus.status === 'incentive-recieved' ||
                  claimIncentiveSuccessStatuses.includes(currMonthStatus.status ?? '')
                ? 'finish'
                : currMonthStatus.status === 'claim-incentive'
                ? currMonthStatus.issue?.id && !currMonthStatus.issue?.isResolved
                    ? 'error'
                    : 'process'
                : 'process',
    },
    {
        id: 'recieve_incentives',
        name: 'Receive Incentives',
        status:
            dhisStatus !== 'dhis-end' || currMonthStatus.status !== 'incentive-recieved'
                ? claimIncentiveSuccessStatuses.includes(currMonthStatus.status ?? '')
                    ? currMonthStatus.issue?.id && !currMonthStatus.issue.isResolved
                        ? 'error'
                        : 'process'
                    : 'wait'
                : currMonthStatus.status === 'incentive-recieved'
                ? currMonthStatus.issue?.id && !currMonthStatus.issue.isResolved
                    ? 'error'
                    : 'finish'
                : 'finish',
    },
];

export function getNextIncentiveState(status: all_states): all_states | undefined {
    if (status === 'incentive-recieved') {
        return 'incentive-recieved';
    }

    if (status === 'dhis-registration') {
        return next_state['dhis-registration'];
    }

    if (status === 'dhis-approval') {
        return next_state['dhis-approval'];
    }

    if (status === 'claim-incentive') {
        return next_state['claim-incentive'];
    }

    if (status === 'confirm-incentive') {
        return next_state['confirm-incentive'];
    }
}
